export const NEURON_API_URL = import.meta.env.VITE_NEURON_API_URL as string;
export const NEURON_API_TOKEN = import.meta.env.VITE_NEURON_API_TOKEN as string;
export const NEURON_CONFIG_URL = import.meta.env
  .VITE_NEURON_CONFIG_URL as string;

export const SEGMENTO_API_URL = import.meta.env.VITE_SEGMENTO_API_URL as string;

export const MODE = import.meta.env.MODE;

export const NEW_RELIC_KEY = import.meta.env.VITE_NEW_RELIC_KEY as string;

export const LIVE_RAMP_PID = import.meta.env.VITE_LIVE_RAMP_PID as string;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export const CAS_API_KEY = import.meta.env.VITE_CDP_API_KEY as string;

export const CAS_ACTIVATION_URL = import.meta.env
  .VITE_CDP_ACTIVATION_URL as string;

export const BC_PLAYER_ID = import.meta.env.VITE_BC_PLAYER_ID as string;

export const MYSPH_LIGHTBOX2_CLIENTID = import.meta.env
  .VITE_PUBLIC_MYSPH_LIGHTBOX2_CLIENTID as string;
export const MYSPH_LIGHTBOX2_JS = import.meta.env
  .VITE_PUBLIC_MYSPH_LIGHTBOX2_JS as string;

export const IDPF_SESSION_VALIDATION_ENDPOINT = import.meta.env
  .WEB2_BUILD_IDP_VALIDATE_API_URL as string;
export const IDPF_SESSION_VALIDATION_API_KEY = import.meta.env
  .WEB2_BUILD_IDP_VALIDATE_API_KEY as string;

export const BC_PLAYER_ID_SMALL_WIDGET = import.meta.env
  .VITE_BC_PLAYER_ID_SMALL_WIDGET as string;

export const INCLUDE_SMX_FORMAT_OPTIONS = import.meta.env
  .VITE_INCLUDE_SMX_FORMAT_OPTIONS as string;

export const HOME_STORY_QUEUE_ID = import.meta.env
  .VITE_HOME_STORY_QUEUE_ID as string;

export const NEWSLETTER_STORY_QUEUE_ID = import.meta.env
  .VITE_NEWSLETTER_STORY_QUEUE_ID as string;

export const CAS_EI_MODEL_ID = import.meta.env.VITE_CDP_EI_ID as number;

export const EMARSYS_URL = import.meta.env.VITE_EMARSYS_BASE_URL as string;
export const EMARSYS_SEGMENT_ID = import.meta.env
  .VITE_EMARSYS_SEGMENT_ID as string;
export const EMARSYS_CLIENT_ID = import.meta.env
  .VITE_EMARSYS_CLIENT_ID as string;

export const DRUPAL_API_ENDPOINT = import.meta.env
  .VITE_DRUPAL_API_ENDPOINT as string;

export const FB_AUTH_DOMAIN = import.meta.env.VITE_FB_AUTH_DOMAIN as string;
export const FB_DATABASE_URL = import.meta.env.VITE_FP_DATABASE_URL as string;
export const FB_PROJECT_ID = import.meta.env.VITE_FB_PROJECT_ID as string;
export const FB_STORAGE_BUCKET = import.meta.env
  .VITE_FB_STORAGE_BUCKET as string;
export const FB_MESSAGING_SENDER_ID = import.meta.env
  .VITE_FB_MESSAGING_SENDER_ID as string;
export const FB_APP_ID = import.meta.env.VITE_FB_APP_ID as string;
export const FB_TOKEN_TOPIC = import.meta.env.VITE_FB_TOKEN_TOPIC as string;
export const FB_CLIENT_EMAIL = import.meta.env.VITE_FB_CLIENT_EMAIL as string;
export const REACT_APP_URL = import.meta.env.VITE_REACT_APP_URL as string;
export const FB_MEASURMENT_ID = import.meta.env
  .VITE_FB_MEASUREMENT_ID as string;

export const CAS_CDP_PAYWALL_ID = import.meta.env.VITE_CDP_PAYWALL_ID as number;
export const CAS_CDP_REGWALL_ID = import.meta.env.VITE_CDP_REGWALL_ID as number;
export const MYSPH_NOT_AVAILABLE = import.meta.env
  .VITE_MYSPH_NOT_AVAILABLE as string;

export const ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT;

export const ADS_DOMAIN: string =
  ENVIRONMENT == "prd"
    ? "https://adtag.sphdigital.com"
    : "https://adtag-stg.sphdigital.com";

export const BH_BASE_URL: string =
  ENVIRONMENT === "prd"
    ? "https://www.beritaharian.sg/"
    : "https://uat.beritaharian.sg/";

export const BH_BASS_URL = import.meta.env.VITE_BH_BASS_URL as string;

export const EPAPER_LINK = import.meta.env.VITE_EPAPER_LINK as string;

export const WEBINAR_PLAYLIST_ID = import.meta.env
  .VITE_WEBINAR_PLAYLIST_ID as string;
export const WEBINAR_ESHOP_LINK = import.meta.env
  .VITE_WEBINAR_ESHOP_LINK as string;

export const BH_CAS_BASE_URL: string =
  ENVIRONMENT === "prd"
    ? "https://cdp.sph.com.sg/"
    : "https://uat-cdp.sph.com.sg/";

export const BH_MOBILE_BANNERS_UGC: string =
  ENVIRONMENT === "prd" ? "1300" : "1768";

export const BH_GE_RECORDED_VIDEO: string =
  ENVIRONMENT === "prd" ? "1312" : "1750";
export const BH_GE_LIVE_BLOG_WIGET: string =
  ENVIRONMENT === "prd" ? "1388" : "1747";
export const BH_BUDGET_BOOKLET_WIDGET: string =
  ENVIRONMENT === "prd" ? "1533" : "1751";

export const NEWSLETTER_TEST_SEGMENT_ID =
  ENVIRONMENT === "prd"
    ? "6a83e2f24ffbe4d0c8f41870"
    : "6a589fbf15c9a45cbbdd3b75";

export const NEWSLETTER_TEST_SEGMENT_NAME = "BH Dev Testing";

export const NEWSLETTER_PROD_SEGMENT_ID = "6a958acb389bb7bf4ba16030";
export const NEWSLETTER_PROD_SEGMENT_NAME = "BH_NL_DailyNews_ALL_Daily";

export const GRAPESHOT_API_ENDPOINT = import.meta.env
  .VITE_GRAPESHOT_API_ENDPOINT as string;
export const ENABLE_TTS = import.meta.env.VITE_ENABLE_TTS as string;
export const ENABLE_ONETRUST = import.meta.env.VITE_ENABLE_ONETRUST as string;

export const ONETRUST_URL = import.meta.env.VITE_ONETRUST_URL as string;

export const BEYOND_WORDS_PROJECT_ID = import.meta.env
  .VITE_BEYOND_WORDS_PROJECT_ID as string;

export const IS_PLAYWRIGHT_TEST = import.meta.env
  .VITE_IS_PLAYWRIGHT_TEST as string;

export const VWO_SMART_CODE_ACCOUNT_ID = import.meta.env
  .VITE_VWO_SMART_CODE_ACCOUNT_ID as string;

export const NDR_FEATURE_ENABLE =
  import.meta.env.VITE_NDR_FEATURE_ENABLE === "1";

export const PRESIDENT_ADDRESS_FEATURE_ENABLE =
  import.meta.env.VITE_PRESIDENT_ADDRESS_FEATURE_ENABLE === "1";

export const SHORT_FORM_VIDEOS_PLAYLIST_ID = import.meta.env
  .VITE_SHORT_FORM_VIDEOS_PLAYLIST_ID as string;

export const GA_PROPERTY_ID = import.meta.env.VITE_GA_PROPERTY_ID as string;
export const BH_BC_ACCOUNT_ID = import.meta.env.VITE_BH_BC_ACCOUNT_ID as string;

export const BC_PLAYER_ID_QUICK_NEWS = import.meta.env
  .VITE_BC_PLAYER_ID_QUICK_NEWS as string;

export const QUICKNEWS_RECOMMENDATION_FLAG = import.meta.env
  .VITE_QUICKNEWS_RECOMMENDATION_FLAG as string;

export const QUICKNEWS_FLAG = import.meta.env.VITE_QUICKNEWS_FLAG as string;

export const LONG_FORM_VIDEOS_PLAYLIST_ID = import.meta.env
  .VITE_LONG_FORM_VIDEOS_PLAYLIST_ID as string;

export const NEWSLETTER_CAMPAIGN_DOMAIN = import.meta.env
  .VITE_NEWSLETTER_CAMPAIGN_DOMAIN as string;

export const NEWSLETTER_MOENGAGE_TEAM =
  (import.meta.env.VITE_NEWSLETTER_MOENGAGE_TEAM as string) ||
  "Berita_HarianMoeTest";

export const BC_PLAYLIST_PLAYER_ID = import.meta.env
  .VITE_BC_PLAYLIST_PLAYER_ID as string;

export const ENABLE_ARTICLE_REDESIGN =
  import.meta.env.VITE_ENABLE_ARTICLE_REDESIGN === "1";

// EMTM-1621: eShop–eSaaS subscription touchpoint. When enabled, the subscribe
// CTAs (header, footer, user/mobile menu) point to the on-domain subscribe page
// (ESHOP_SUBSCRIBE_URL) and open in the same tab, instead of the external
// subscribe.sph.com.sg link.
export const ENABLE_ESHOP_SUBSCRIBE =
  import.meta.env.VITE_ENABLE_ESHOP_SUBSCRIBE === "1";

// On-domain subscribe URL used when ENABLE_ESHOP_SUBSCRIBE is on. Set per
// environment by the deploy pipeline (UAT: /internal/subscribe, PROD: /subscribe).
export const ESHOP_SUBSCRIBE_URL = import.meta.env.VITE_ESHOP_SUBSCRIBE_URL;
